import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { get, merge, assign, omit, isEmpty, pick, find, cloneDeep, forEach } from 'lodash';
import { withRouter } from 'react-router';
import * as jobRequestApi from '../../../../redux/actionCreators/async/jobrequests';
import * as jobRequestStore from '../../../../redux/actionCreators/sync/jobrequests';
import * as jobRequestDocumentsApi from '../../../../redux/actionCreators/async/jobrequestDocuments';
import { getSchema as getJobSchema } from '../../../../models/jobRequest';
import { validate, validateField } from '../../../../modelValidator';
import TextField from '../../../../common/components/c_TextField';
import ToggleButton from '../../../../common/components/c_ToggleButton';
import DropDownMenu from '../../../../common/components/c_DropDownMenu';
import SubmissionBar from '../../SubmissionBar';
import RouteTransitionBlocker from '../../../r_ApplicantDashboard/f_RouteTransitionBlocker';
import NextStepBlocker from '../NextStepBlocker';
import shortId from 'shortid';
import { parentChildList } from '../../../../lib/parentChildList';

const yesNo = [{ value: true, primaryText: 'Yes', subElement: 'localJobDetails' }, { value: false, primaryText: 'No', subElement: null }];

const addressSchema = {
  position: {
    city: {
      required: {
        message: 'This field is required.'
      }
    },
    state: {
      required: {
        message: 'This field is required.'
      }
    }
  }
};

@connect((state) => {
  return {
    staticData: state.staticData,
    user: state.user,
    contactProfile: state.contactProfile,
    jobRequest: state.jobRequest,
    documents: state.jobRequestDocuments.documents,
    labels: get(state, 'labels.jobRequest.position', {}),
  };
})
class PositionInfo extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    staticData: PropTypes.object.isRequired,
    user: PropTypes.object,
    jobRequest: PropTypes.object,
    contactProfile: PropTypes.object,
    checkComplete: PropTypes.func,
    router: PropTypes.object,
    route: PropTypes.object,
    location: PropTypes.object,
    params: PropTypes.object,
    documents: PropTypes.array,
    labels: PropTypes.object,
  }

  constructor(props, context) {
    super(props, context);

    this.handleUI = :: this.handleUI;
    this.handleUIDropdown = :: this.handleUIDropdown;

    this.handleChange = :: this.handleChange;

    this.state = {
      clientId: this.props.user.profileId,
      jobRequestModel: {},
      isDirty: false,
      showTransitionBlocker: false,
      showNextStepBlocker: false,
      transitionRoute: '',
      stateSaved: true,
      primaryButtonLabel: undefined,
      secondaryButtonLabel: undefined,
      canSubmit: true
    };

    this.positionInfoFields = ['id', 'primaryContactId', 'industryTypeId', 'segmentTypeId', 'positionTypeId', 'licenseRequired', 'dualMonitorsRequired',
      'outsideContactRequired', 'numberOfPeople', 'fromDifferentOffice',
      'companyName', 'address', 'address2', 'city', 'state', 'zip', 'segmentOther', 'industryOther'];

    this.parentChildHandlers = parentChildList();

  }


  componentDidMount() {

    if (isEmpty(this.state.jobRequestModel) && !isEmpty(this.props.jobRequest)) {
      this.setState(assign({}, this.state, { jobRequestModel: this.props.jobRequest }));
    }

    this.props.router.setRouteLeaveHook(this.props.route, (location) => {

      const newJobRequestSteps = /\/client\/jobrequest\/0\/(.*)/;
      const savedJobRequestSteps = /\/client\/jobrequest\/(.*)\/(.*)/;
      const errors = validate(this.state.jobRequestModel, getJobSchema()['position']);

      if (savedJobRequestSteps.test(location.pathname)) {
        this.state.primaryButtonLabel = 'Stay';
        this.state.secondaryButtonLabel = 'Leave';

      } else {
        this.state.primaryButtonLabel = undefined;
        this.state.secondaryButtonLabel = undefined;
      }

      if (newJobRequestSteps.test(location.pathname)) {
        this.setState(merge({}, this.state, { showTransitionBlocker: false, showNextStepBlocker: true, transitionRoute: location.pathname }));
        return false;
      } else if (!this.state.stateSaved) {
        this.setState(merge({}, this.state, { showTransitionBlocker: true, showNextStepBlocker: false, transitionRoute: location.pathname }));
        return this.state.stateSaved;
      }

      if (savedJobRequestSteps.test(location.pathname) && errors.length > 0) {
        this.setState({ isDirty: true });
        return false;
      }

    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.jobRequest) {
      this.setState(assign({}, this.state, { jobRequestModel: nextProps.jobRequest }));
    }
  }

  isFromDifferentOffice = () => {
    return get(this.state, 'jobRequestModel.fromDifferentOffice', false);
  }

  jobRequestSchema() {
    let schema = cloneDeep(getJobSchema());
    if (this.isFromDifferentOffice()) {
      schema = merge({}, schema, cloneDeep(addressSchema));
    }
    if (this.props.labels) {
      forEach(this.props.labels, (val, key) => {
        if (!this.props.labels[key]) delete schema.position[key];
      });
    }

    schema = this.industryOtherSchema(schema);
    schema = this.segmentOtherSchema(schema);
    return schema;
  }

  segmentOtherSchema(schema) {
    const segmentTypes = get(this.props.staticData, 'jobRequestSegmentTypes');
    const otherSegmentType = get(find(segmentTypes, { name: 'Other' }), 'id');
    if (!!(this.state.jobRequestModel.segmentTypeId && this.state.jobRequestModel.segmentTypeId === otherSegmentType)) {
      schema = merge({}, schema, {
        position: {
          segmentOther: {
            required: {
              message: 'This field is required'
            }
          }
        }
      });
    }
    return schema;
  }

  industryOtherSchema(schema) {
    const industryTypes = get(this.props.staticData, 'industryTypesList');
    const otherIndustryType = get(find(industryTypes, { name: 'Other' }), 'id');
    if (!!(this.state.jobRequestModel.industryTypeId &&
      this.state.jobRequestModel.industryTypeId === otherIndustryType)) {
      schema = merge({}, schema, {
        position: {
          industryOther: {
            required: {
              message: 'This field is required'
            }
          }
        }
      });
    }
    return schema;
  }

  handleChange(prop) {
    return (event, value) => {
      const jobRequest = this.state.jobRequestModel;
      jobRequest[prop] = value;
      this.setState(merge({}, this.state, { jobRequestModel: jobRequest, stateSaved: false, isDirty: true }));
    };
  }

  handleOfficeChange() {
    return (event, value) => {
      const {
        jobRequestModel = {}
      } = merge({}, this.state);
      jobRequestModel['fromDifferentOffice'] = value;
      if (!value) {
        ['city', 'state', 'address', 'address2', 'zip']
          .forEach(prop => jobRequestModel[prop] = null);
      }
      this.setState(merge({}, this.state, { jobRequestModel, stateSaved: false, isDirty: true }));
    };
  }

  handleUI(prop, label) {

    const errorText = this.state.isDirty && this.jobRequestSchema().position[prop] !== undefined ?
      validateField(this.state.jobRequestModel[prop], this.jobRequestSchema().position[prop])[0] : undefined;

    return {
      'data-id': prop,
      value: this.state.jobRequestModel[prop],
      errorText,
      onChange: this.handleChange(prop),
      floatingLabelText: label || null,
      isDirty: this.state.isDirty
    };
  }

  handleUIDropdown(prop, label, menuItems) {
    const byName = (item1, item2) =>
      item1.name.localeCompare(item2.name)
      ;

    return {
      menuItems: menuItems.sort(byName),
      ...this.handleUI(prop, label)
    };
  }

  handleOfficeUI(prop, label) {
    return merge({}, this.handleUI(prop, label), { onChange: this.handleOfficeChange() });
  }

  submitCallback(doNext) {
    return {
      success: (data) => {
        const jobId = this.state.jobRequestModel.id || data[0].id;

        // update store
        if (data[0]) {

          const positionInfo = pick({ ...data[0] }, this.positionInfoFields);
          const jobRequest = merge(positionInfo, { ...this.state.jobRequestModel });

          this.props.dispatch(jobRequestStore.updateJobRequest(jobRequest));
        }
        else {
          this.props.dispatch(jobRequestStore.updateJobRequest({ ...this.state.jobRequestModel }));
        }
        this.props.checkComplete();
        this.props.dispatch(push(doNext ? `/client/jobRequest/${jobId}/description` : `/client/jobRequest/${jobId}`));
      }
    };
  }


  handleSubmit = (doNext) => {

    const schema = this.jobRequestSchema()['position'];
    const errors = doNext ? validate(this.state.jobRequestModel, schema) : [];

    if (errors.length > 0) {
      this.setState({ isDirty: true });
    }
    else {

      this.setState({ canSubmit: false });
      const positionInfo = pick(this.state.jobRequestModel, this.positionInfoFields);

      if (this.props.location.query.hasOwnProperty('clone')) {
        this.clone(this.state.clientId, positionInfo, this.state.jobRequestModel, doNext);
        return;
      }

      if (this.props.params.jobId === 0 || this.props.params.jobId === undefined) {
        this.props.dispatch(jobRequestApi.createJobRequest(this.state.clientId, positionInfo, this.submitCallback(doNext)));
      }
      else {
        this.props.dispatch(jobRequestApi.updateJobRequest(this.state.clientId, positionInfo, this.submitCallback(doNext)));
      }
      this.setState({ stateSaved: true, canSubmit: true });
    }
  }

  clone(primaryContactId, positionInfo, jobrequest, doNext) {

    // Create.
    const createJobRequest = () => this.props.dispatch(jobRequestApi.createJobRequest(primaryContactId, positionInfo));

    // Save.
    const updateJobRequest = (jobId) => {
      const jobrequestFiltered = omit(jobrequest, ['id', 'primaryContact', 'clone', 'jobRequestStatus', 'contact', 'dateCreated', 'dateModified', 'dateAuthorized', 'dateLastExported', 'crmEntityId', 'payRate', 'billRate', 'placementSpecialistId']);
      return this.props.dispatch(jobRequestApi.updateJobRequest(primaryContactId, { id: jobId, ...jobrequestFiltered }));
    };

    // Save Documents.
    const saveNewDocument = (jobId, document) => {

      const clientId = `${jobrequest.id}${shortId.generate()}`;
      this.props.dispatch(jobRequestDocumentsApi.createJobRequestDocuments(this.props.user.profileId, { ...document, jobId, clientId }));

    };

    createJobRequest()
      .then((resp) => {
        jobrequest.id = resp[0].id;
        this.props.documents.map(document => saveNewDocument(jobrequest.id, document));
        return updateJobRequest(resp[0].id);
      })
      .then(() => {
        this.setState({ stateSaved: true }, () => {
          this.props.dispatch(jobRequestStore.updateJobRequest(jobrequest));
          this.props.checkComplete();
          this.props.dispatch(push(doNext ? `/client/jobRequest/${jobrequest.id}/description` : `/client/jobRequest/${jobrequest.id}`));
        });

      })
      .catch((err) => {
        this.setState({ canSubmit: true });
        return console.error('Unable to clone', err);
      });

  }

  closeTransitionBlocker = () => {
    this.setState(merge({}, this.state, { showTransitionBlocker: false, showNextStepBlocker: false }));
  }

  transitionFunction = () => {
    this.setState({ stateSaved: true }, () => this.props.dispatch(push(this.state.transitionRoute)));
  }

  render() {

    const isInNewRequestStatus = this.props.jobRequest.jobRequestStatus === 2 && !this.props.location.query.hasOwnProperty('clone') ? true : false;

    const { parent: industryTypeProps, child: segmentTypeProps } = this.parentChildHandlers({
      parentProps: this.handleUIDropdown('industryTypeId', undefined, this.props.staticData.industryTypesList),
      childProps: this.handleUIDropdown('segmentTypeId', undefined, this.props.staticData.jobRequestSegmentTypes),
    });

    const segmentTypes = get(this.props.staticData, 'jobRequestSegmentTypes');
    const otherSegmentType = get(find(segmentTypes, { name: 'Other' }), 'id');
    const industryTypes = get(this.props.staticData, 'industryTypesList');
    const otherIndustryType = get(find(industryTypes, { name: 'Other' }), 'id');

    return (
      <div className='position-info'>
      {
        this.state.showTransitionBlocker &&
          <RouteTransitionBlocker
            cancelAction={this.closeTransitionBlocker.bind(this)}
            primaryAction={this.closeTransitionBlocker.bind(this)}
            primaryButtonLabel={this.state.primaryButtonLabel}
            secondaryAction={this.transitionFunction.bind(this)}
            secondaryButtonLabel={this.state.secondaryButtonLabel}
            transitionText={'You are leaving the Job Request record. Please click on Save first before you exit.'}
          />
      }
      {
        this.state.showNextStepBlocker &&
        <NextStepBlocker
          cancelFunc={this.closeTransitionBlocker.bind(this)}
          transitionText={'You are leaving the Job Request record. Please click on Save first before you exit.'}
          />
      }
      {
        <span>
          <h1>Position Information</h1>
          <div className='form'>

            <div className='field'>
              <div className='label'>{this.props.labels.industryTypeId}</div>
              <DropDownMenu
                data-id='question-dropdown-industry-type'
                {...industryTypeProps}
                disabled={isInNewRequestStatus}
              />
              {
                this.props.labels.industryTypeIdSubText
                &&
                <div className='label'>{this.props.labels.industryTypeIdSubText}</div>
              }
            </div>

            {
              !!(this.state.jobRequestModel.industryTypeId && this.state.jobRequestModel.industryTypeId === otherIndustryType)
              &&
              <div className='field other'>
                <div className='label'>If other, please specify</div>
                <TextField
                  floatingLabelText='Firm type Other'
                  {...{ required: { message: 'This field is required' } }}
                  {...this.handleUI('industryOther')} />
              </div>
            }

            <div className='field'>
              <div className='label'>{this.props.labels.segmentTypeId}</div>
              <DropDownMenu
                data-id='question-dropdown-segment-type'
                disabled={isInNewRequestStatus}
                {...segmentTypeProps}
              />
              {
                this.props.labels.segmentTypeIdSubText
                &&
                <div className='label'>{this.props.labels.segmentTypeIdSubText}</div>
              }
            </div>

            {
              !!(this.state.jobRequestModel.segmentTypeId && this.state.jobRequestModel.segmentTypeId === otherSegmentType)
              &&
              <div className='field other'>
                <div className='label'>If other, please specify</div>
                <TextField
                  floatingLabelText='Industry Segment Other'
                  {...this.handleUI('segmentOther')} />
              </div>
            }

            <div className='field'>
              <div className='label'>{this.props.labels.positionTypeId}</div>
              <DropDownMenu
                data-id='question-dropdown-position-type'
                disabled={isInNewRequestStatus}
                {...this.handleUI('positionTypeId')}
                menuItems={this.props.staticData.positionTypes}
                underlineStyle={{ margin: '-1px 0px' }}
                iconStyle={{ right: '0px', fill: 'rgb(33, 35, 38)' }}
                labelStyle={{ paddingLeft: '0px' }}
              />
            </div>

            {
              this.props.labels.licenseRequired
              &&
              <div className='field'>
                <div className='label'>{this.props.labels.licenseRequired}</div>
                <ToggleButton
                  menuItems={yesNo}
                  {...this.handleUI('licenseRequired')}
                />
              </div>
            }

            <div className='field'>
              <div className='label'>Does the job require use of dual monitors?</div>
              <ToggleButton
                menuItems={yesNo}
                {...this.handleUI('dualMonitorsRequired')}
              />
            </div>

            <div className='field'>
              <div className='label'>Does the job require phone contact with people outside the company?</div>
              <ToggleButton
                menuItems={yesNo}
                {...this.handleUI('outsideContactRequired')}
              />
            </div>

            <div className='field'>
              <div className='label'>Number of people for this type of work</div>
              <TextField
                {...this.handleUI('numberOfPeople')}
                type='number'
                min='1'
              />
            </div>

            <div className='field'>
              <div className='label'>Is this job opening for a different office from your office?</div>
              <ToggleButton
                menuItems={yesNo}
                {...this.handleOfficeUI('fromDifferentOffice')}
              />
            </div>

          </div>
        </span>
      }
      {
        this.isFromDifferentOffice() &&
        <div className='form-extra-section'>

          <div className='field'>
            <TextField
              {...this.handleUI('companyName', 'Company Name')}
              disabled={true}
              floatingLabelFixed={true}
              defaultValue={this.props.contactProfile.company.name}
            />
          </div>
          <div className='field'>
            <TextField floatingLabelFixed={true} {...this.handleUI('address', 'Address')} />
          </div>
          <div className='field'>
            <TextField floatingLabelFixed={true} {...this.handleUI('address2', 'Address Line 2')} />
          </div>
          <div className='field'>
            <TextField floatingLabelFixed={true} {...this.handleUI('city', 'City')} />
          </div>
          <div className='field'>
            <DropDownMenu
              canAutoPosition={true}
              {...this.handleUI('state', 'State')}
              floatingLabelFixed={true}
              menuItems={this.props.staticData.stateList}
              underlineStyle={{ margin: '-1px 0px' }}
              iconStyle={{ right: '0px', fill: 'rgb(33, 35, 38)' }}
              labelStyle={{ paddingLeft: '0px' }}
            />
          </div>
          <div className='field'>
            <TextField floatingLabelFixed={true} {...this.handleUI('zip', 'Zip')} />
          </div>
        </div>
      }
      <SubmissionBar
        onNext={() => this.handleSubmit(true)}
        onSave={() => this.handleSubmit(false)}
        submitDisabled={!this.state.canSubmit}
      />
      </div>
    );
  }
}
export default withRouter(PositionInfo);



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/PositionInfo/index.js